import React from 'react';
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../components/ui/alert-dialog';

// ─── DeleteCategoryDialog ──────────────────────────────────────────
// Simple confirm dialog for the "Delete collection" action in the
// sidebar's per-category menu. Bookmarks aren't deleted — they just
// lose their category_id assignment. Open state is derived from a
// `pendingId` (truthy = open, null = closed) so the parent doesn't
// need a separate boolean.
export function DeleteCategoryDialog({ pendingId, onCancel, onConfirm }) {
    return (
        <AlertDialog open={!!pendingId} onOpenChange={(open) => { if (!open) onCancel(); }}>
            <AlertDialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-md rounded-2xl">
                <AlertDialogHeader>
                    <AlertDialogTitle>Delete collection?</AlertDialogTitle>
                    <AlertDialogDescription>Bookmarks in this collection will be kept but uncategorized.</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel className="rounded-xl">Cancel</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={() => onConfirm(pendingId)}
                        className="rounded-xl bg-destructive text-destructive-foreground hover:bg-destructive/90"
                    >
                        Delete
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
